// components/BuilderHeader.tsx
import React from 'react';
import { Paper, Group, Title, Badge, Button, ActionIcon, Text } from '@mantine/core';
import { IconEye, IconArrowLeft, IconRefresh } from '@tabler/icons-react';

export interface BuilderHeaderProps {
  title: string;
  subtitle?: string;
  published?: boolean;
  saving?: boolean;
  readonly?: boolean;
  onBack?: () => void;
  onPreview: () => void;
  onDone?: () => void;
  onReload?: () => void;
}

export function BuilderHeader({
  title,
  subtitle,
  published,
  saving,
  readonly,
  onBack,
  onPreview,
  onDone,
  onReload,
}: BuilderHeaderProps) {
  return (
    <Paper withBorder p="md" radius="md" mb="md">
      <Group justify="space-between">
        <Group>
          {onBack && (
            <ActionIcon variant="subtle" onClick={onBack}>
              <IconArrowLeft size={18} />
            </ActionIcon>
          )}
          <div>
            <Title order={4}>{title}</Title>
            {subtitle && <Text size="xs" c="dimmed">{subtitle}</Text>}
          </div>
          {published && <Badge color="green">Published</Badge>}
          {readonly && <Badge color="gray">Read-only</Badge>}
        </Group>
        <Group>
          {onReload && (
            <ActionIcon variant="subtle" onClick={onReload}>
              <IconRefresh size={18} />
            </ActionIcon>
          )}
          <Button variant="default" leftSection={<IconEye size={16} />} onClick={onPreview}>
            Preview
          </Button>
          {!readonly && (
            <Button loading={saving} onClick={onDone}>
              Done
            </Button>
          )}
        </Group>
      </Group>
    </Paper>
  );
}